import React, { useEffect, useState } from 'react';

import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSignalRContext } from '../../../signalR/signalRProvider';
import { useSignalRListener } from '../../../signalR/useSignalRListener';

/**
 * Muestra al currentUser si se está editando el formulario por otro usuario
 * @param {currentUser, currentFormId, isDirty, setDisabled} param0 
 * @returns 
 */
const EditingUser = ({ currentUser, currentFormId, isDirty, onCurrentEditorChange }) => {
    const { t } = useTranslation();
    const [editingUser, setEditingUser] = useState(null);
    const { isConnected, sendMessage } = useSignalRContext();

    const currentUserId = currentUser.sub;
    const fullName = `${currentUser.given_name} ${currentUser.family_name}`;

    function notifyEditingUser(editor) {
        setEditingUser(editor);
        onCurrentEditorChange(editor);
    }

    /** Verifica si existe algun editor al momento de cargar el form */
    useEffect(() => {
        if (isConnected) {
            sendMessage("GetCurrentEditor", currentFormId).then(editor => {
                if (editor)
                    notifyEditingUser(editor);
                else
                    setEditingUser(null);
            })
        }

        return () => {
            if (isConnected)
                sendMessage("NotifyStopEditing", currentFormId, currentUserId, fullName);
        };
    }, [isConnected, currentFormId]);

    /** Maneja el cerrado/refresco de Pestaña. Notifica q se dejó de editar. */
    useEffect(() => {
        const handleBeforeUnload = async () => {
            if (isConnected) {
                sendMessage("NotifyStopEditing", currentFormId, currentUserId, fullName);
            }
        };

        if (isConnected)
            window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isConnected]);

    /** Si cambio algún dato del form, notifico a los usuarios que se está editando.  */
    useEffect(() => {
        if (isConnected) {
            if (isDirty)
                sendMessage("NotifyEditing", currentFormId, currentUserId, fullName);
            else
                sendMessage("NotifyStopEditing", currentFormId, currentUserId, fullName);
        }

    }, [isConnected, isDirty]);

    /** Escucha por si otro usuario empezó a editar */
    useSignalRListener("UserEditing", (tenantId, formId, userId, fullName) => {
        console.log("📩 Mensaje recibido UserEditing:", tenantId, formId, userId, fullName);
        if (currentUser.tenantId == tenantId && formId === currentFormId) {
            notifyEditingUser({ formId, userId, fullName });
        }
    });

    /** Escucha por si otro usuario dejó de editar */
    useSignalRListener("UserStopEditing", (tenantId, formId, userId, fullName) => {
        console.log("📩 Mensaje recibido UserStopEditing:", tenantId, formId, userId, fullName, currentUserId);
        if (currentUser.tenantId == tenantId && formId === currentFormId) {
            setEditingUser(null);
        }

        onCurrentEditorChange({ formId, userId, fullName });
    });

    if (editingUser) {
        const editingUserFullName = editingUser?.fullName;
        return <Alert style={{ marginBottom: "20px", backgroundColor: "#b36413" }}><b>{t("protocolNotifications.visitTracking_formUserIsEditing", { editingUserFullName })}</b></Alert>;
    }
    else
        return null;
}

export default EditingUser;

